<template>
    <div
        class="nav-history-sub-item relative text-xs group flex gap-2 px-4 text-gray-40 min-h-[36px] items-center cursor-pointer hover:bg-gray-hover w-full min-w-0"
        :class="activeClass"
        :title="getTitle(child)"
        @click="clickHistory(child)"
    >
        <slot name="historyIcon" :item="child">
            <img
                v-if="child.icon_url"
                :src="child.icon_url"
                class="shrink-0 !size-4"
                :class="{'invert': !inTooltip}"
            >
            <component
                :is="getIconName(child.type)"
                v-else-if="child.type"
                class="patsnap-biz-icon shrink-0 text-base"
                :class="{'tooltip-item-icon': inTooltip}"
            />
        </slot>
        <span class="flex-1 line-clamp-1 text-sm" :class="{'tooltip-item-text': inTooltip}">{{ child.title }}</span>
        <span
            class="shrink-0 items-center justify-center px-0.5 py-0.5 rounded !hidden group-hover:!flex hover:bg-gray-hover"
            @click.stop="removeHistory(child)"
        >
            <PtIcon class="shrink-0 text-base" :class="{'tooltip-item-icon': inTooltip}" icon="SolidDeleteStroke" />
        </span>
    </div>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import PtIcon from '@patsnap-biz/icon';
import Hiro from './icons/Hiro.vue';
import Telecom from './icons/Telecom.vue';
import DesignFTOSearch from './icons/DesignFTOSearch.vue';
import AgentIcon from './icons/AgentIcon.vue';
import PLGIcon from './icons/PLGIcon.vue';
import ResearchIcon from './icons/ResearchIcon.vue';
import PatentDisclosure from './icons/PatentDisclosure.vue';
import RiskIcon from './icons/RiskIcon.vue';
import AIFTOSearchIcon from './icons/AIFTOSearchIcon.vue';
import AINoveltySearchIcon from './icons/AINoveltySearchIcon.vue';
import AIPatentDisclosureIcon from './icons/AIPatentDisclosureIcon.vue';
import AISpecificationIcon from './icons/AISpecificationIcon.vue';
import AITranslationIcon from './icons/AITranslationIcon.vue';
import TrizMindIcon from './icons/TrizMindIcon.vue';
import CompanyScoutIcon from './icons/CompanyScoutIcon.vue';
import RDTechMindIcon from './icons/TechMindIcon.vue';
import LSChatIcon from './icons/LSChatIcon.vue';
import { IMenuType } from '../types';
import type { IMenuItem } from '../types';
import { BORDER_ACTIVE_CLASS, LIGHT_ACTIVE_CLASS } from '../constants';

import '@patsnap-ui/icon/assets/solid/DeleteStroke.svg';

const props = defineProps<{
    child: IMenuItem;
    inTooltip?: boolean;
}>();

const messages = inject('messages', {});
const clickHistory = inject<(item: IMenuItem) => void>('clickHistory', () => {});
const removeHistory = inject<(item: IMenuItem) => void>('removeHistory', () => {});

const { t } = useI18n({
    messages,
});

const activeClass = computed(() => {
    if (props.child.active) {
        if (props.inTooltip) {
            return LIGHT_ACTIVE_CLASS;
        }
        return BORDER_ACTIVE_CLASS;
    }
    return '';
});

function getIconName(type: IMenuType) {
    switch (type) {
    case IMenuType.IP_Hiro:
        return Hiro;
    case IMenuType.IP_TELECOM_AICC:
        return Telecom;
    case IMenuType.AI_FTO_IMAGE:
        return DesignFTOSearch;
    case IMenuType.TECH_RESEARCH:
        return ResearchIcon;
    case IMenuType.TECH_FMEA:
        return RiskIcon;
    case IMenuType.PATENT_DISCLOSURE:
        return PatentDisclosure;
    case IMenuType.AI_TRANSLATION:
        return AITranslationIcon;
    case IMenuType.AI_SPECIFICATION:
        return AISpecificationIcon;
    case IMenuType.AI_PATENT_DISCLOSURE:
        return AIPatentDisclosureIcon;
    case IMenuType.AI_NOVELTY_SEARCH:
        return AINoveltySearchIcon;
    case IMenuType.AI_FTO_SEARCH:
    case IMenuType.AI_NEW_FTO_SEARCH:
        return AIFTOSearchIcon;
    case IMenuType.TRIZ_MIND:
        return TrizMindIcon;
    case IMenuType.COMPANY_SCOUT:
        return CompanyScoutIcon;
    case IMenuType.PLG_QA:
        return PLGIcon;
    case IMenuType.RD_TECH_MIND:
        return RDTechMindIcon;
    case IMenuType.LS_CHAT:
        return LSChatIcon;
    default:
        return AgentIcon;
    }
}

function getTitle(item: IMenuItem) {
    if (item.business_name) {
        return `${item.business_name}: ${item.title}`;
    }
    return item.title || '';
}
</script>
